export default {
  name: "workgroup_order",
  data: () => ({
    workgroup_order_limit: 10,
    workgroup_order_page: 1,
    total_workgroup_order: 1,
    workgroup_orders: [],
  }),
  methods: {
    async getWorkgroupOrderList(workgroup_id) {
      const res = this.$communicator.then(
        this,
        await this.$communicator("get_workgroup_order_list", {
          params: {
            workgroup_id: workgroup_id,
            limit: this.workgroup_order_limit,
            page: this.workgroup_order_page,
          },
        })
      );
      if (res) {
        this.workgroup_orders = res.workgroup_orders;
        this.total_workgroup_order = Math.ceil(
          res.total / this.workgroup_order_limit
        );
      }
    },
    async createWorkgroupOrder(data) {
      if (data._id != undefined) {
        return this.$communicator.then(
          this,
          await this.$communicator("workgroup_order_update", {
            arguments: [data._id],
            params: data,
          })
        );
      }
      return this.$communicator.then(
        this,
        await this.$communicator("create_workgroup_order", {
          params: data,
        })
      );
    },
    async getWorkgroupOrderById(id) {
      return this.$communicator.then(
        this,
        await this.$communicator("get_workgroup_get_by_id", {
          arguments: [id],
        })
      );
    },
    async cancelWorkgroupOrder(id) {
      return this.$communicator.then(
        this,
        await this.$communicator("cancel_workgroup_order", {
          arguments: [id],
        })
      );
    },
    async undoWorkgroupOrder(id) {
      return this.$communicator.then(
        this,
        await this.$communicator("undo_workgroup_order", {
          arguments: [id],
        })
      );
    },
    async confirmWorkgroupOrder(id, options) {
      return this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_confirm", {
          arguments: [id],
          params: options,
        })
      );
    },
  },
};
